module.exports = __webpack_public_path__ + "img/submit.fea61799.png";